import { useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Descriptions,
  message,
} from "antd";
import { createDeliveryIssue } from "../../services/DeliveryIssues";

const ISSUE_TYPES = [
  { value: "rider_over_charge", label: "Rider charged customer" },
  { value: "damaged_or_lost", label: "Damaged/Lost" },
];

export default function RaiseDeliveryIssue({
  attempt,
  placedOrderId,
  outlet,
  onIssueRaised,
}) {
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    form.resetFields();
    setOpen(false);
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await createDeliveryIssue({
        placed_order: placedOrderId,
        outlet: outlet?.id,
        delivery: attempt.id,
        issue_type: values.issue_type,
        issue_comment: values.issue_comment,
        created_by: values.created_by,
        ...(values.issue_type === "rider_over_charge" &&
          values.refund_amount != null && {
            refund_amount: values.refund_amount,
          }),
      });
      message.success("Issue raised");
      form.resetFields();
      setOpen(false);
      onIssueRaised?.();
    } catch {
      message.error("Failed to raise issue");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        style={{
          fontWeight: 600,
          borderRadius: 7,
          height: 26,
          padding: "0 10px",
          boxShadow: "none",
          color: "#7C3AED",
          borderColor: "#DDD6FE",
          background: "#F5F3FF",
        }}
      >
        Raise Issue
      </Button>

      <Modal
        title="Raise Delivery Issue"
        visible={open}
        onCancel={handleClose}
        footer={null}
        destroyOnClose
      >
        <Descriptions size="small" column={1} style={{ marginBottom: 16 }}>
          <Descriptions.Item label="Order ID">
            #{placedOrderId}
          </Descriptions.Item>
          <Descriptions.Item label="Attempt No">
            {attempt.attempt_no}
          </Descriptions.Item>
          <Descriptions.Item label="Outlet">{outlet?.name}</Descriptions.Item>
        </Descriptions>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="issue_type"
            label="Issue Type"
            rules={[{ required: true, message: "Required" }]}
          >
            <Select
              placeholder="Select issue type"
              options={ISSUE_TYPES}
              onChange={() => form.resetFields(["refund_amount"])}
            />
          </Form.Item>

          <Form.Item
            name="issue_comment"
            label="Issue Comment"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.TextArea rows={3} />
          </Form.Item>

          <Form.Item
            name="created_by"
            label="Created By"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item noStyle dependencies={["issue_type"]}>
            {({ getFieldValue }) =>
              getFieldValue("issue_type") === "rider_over_charge" ? (
                <Form.Item
                  name="refund_amount"
                  label="Refund Amount"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      type: "number",
                      min: 1,
                      max: 1000,
                      message: "Must be between 1 and 1000",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={1}
                    max={1000}
                    precision={2}
                    placeholder="Enter amount (max ₹1000)"
                  />
                </Form.Item>
              ) : null
            }
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={submitting}
            disabled={submitting}
            block
          >
            Submit
          </Button>
        </Form>
      </Modal>
    </>
  );
}
